import React, { useContext, useEffect, useState } from "react";
import {
  astro_details,
  birth_details,
} from "../../../ApiServices/Horoscope/BirthDetailsApi";
import { GetUserModel } from "../../../ApiServices/Profile/ProfileApi";
import HoroscopeBannerImg from "../../../assets/images/new/HoroscopeBanner.png";
import astroBackgroundImg from '../../../assets/images/Horoscope/horoscopeBackgroundImg.png'
import Breadcrumbs from "../../Breadcrumb";
import { LoaderContext } from "../../../AuthContext/AuthContext";

import astrology from "../../../assets/images/new/astrology.png";
import panchang from "../../../assets/images/new/panchang.png";
import numerology from "../../../assets/images/new/numerology.png";
import zodiacSign from "../../../assets/images/new/zodiacSign.png";
import Astro from "../../../assets/images/new/services1 (1).jpg";
import Panchang from "../../../assets/images/new/services1 (2).jpg";
import Numerology from "../../../assets/images/new/services1 (3).jpg";
import Prediction from "../../../assets/images/new/services1 (3).jpg";
import { useLocation, useNavigate } from "react-router-dom";
const BasicDetails = () => {
  const [animate, setAnimate] = useState(false);
  const [basicDetails, setBasicDetailsObj] = useState([]);
  const [astroDetails, setAstroDetailsObj] = useState([]);
  const { setLoader, pujaStatus, fetchedLocation, timezoneOffset, convertTo12Hour } = useContext(LoaderContext);
  const navigate = useNavigate()
  const location = useLocation()


  const labels = [
    "Year",
    "Month",
    "Day",
    "Hour",
    "Minute",
    // "Latitude",
    // "Longitude",
    // "Timezone",
    "Seconds",
    "Sunrise",
    "Sunset",
    "Ayanamsha",
  ];
  const AstroLabels = [
    'Ascendant',
    'AscendantLord',
    'Varna',
    'Vashya',
    'Yoni',
    'Gan',
    'Nadi',
    'SignLord',
    'Sign',
    'Naksahtra',
    'NaksahtraLord',
    'Charan',
    'Yog',
    'Karan',
    'Tithi',
    'Yunja',
    'Tatva',
    'Alphabet',
    'Paya',
  ];

  const categories = [
    {
      title: "Astrology",
      image: Astro,
      icon: astrology,
      text: "Book Astrology for your spiritual rituals and ceremonies.",
      color: "#ffa415",
      route: "/basic-details",
    },
    {
      title: "Panchang",
      image: Panchang,
      icon: panchang,
      text: "Get a Panchang for your up and down ",
      color: "#fc5528",
      route: "/daily-panchang",
    },
    {
      title: "Numerology",
      image: Numerology,
      icon: numerology,
      text: "Numerology for better life",
      color: "#8139e7",
      route: "/numerology",
    },
    {
      title: "Zodiac Signs",
      image: Prediction,
      icon: zodiacSign,
      text: "Know about Zodiac Prediction",
      color: "#399be7",
      route: "/Prediction ",
    }

  ];

  useEffect(() => {
    GetUserModelData();
    setTimeout(() => {
      setAnimate(true);
    }, 300); // Delay animation to make it smoother
  }, []);

  const GetUserModelData = async () => {
    setLoader(true);

    const userID = JSON.parse(localStorage.getItem("userID"));
    try {
      const response = await GetUserModel(userID);
      if (response?.ResponseCode == 0) {
        setLoader(false);

        const ModelData = response.DATA || []; // Assuming the data is an array and we need the first item
        // debugger
        const dob = new Date(ModelData[0]?.DOB);

        const year = dob.getFullYear();
        const month = dob.getMonth() + 1; // Months are zero-based (0 = January)
        const day = dob.getDate();

        const [hours, minutes] = ModelData[0]?.BIRTH_TIME.split(":");
        const apiParam = {
          day: day,
          month: month,
          year: year,
          hour: hours,
          min: minutes,
          lat: fetchedLocation?.lat,
          lon: fetchedLocation?.lon,
          tzone: timezoneOffset,
        };
        await GetBasicDetails(apiParam);
        await GetAstroDetails(apiParam);
      } else {
        setLoader(false);

        console.error(
          "Error fetching data: ",
          response?.data?.data?.statusCode
        );
      }
    } catch (error) {
      setLoader(false);

      console.error("Error", error);
    }
  };
  const GetBasicDetails = async (apiParam) => {
    setLoader(true);
    try {
      const response = await birth_details(apiParam);
      if (response !== null && response !== undefined) {
        setLoader(false);

        setBasicDetailsObj((prev) => ({
          ...prev,
          Year: response?.year,
          Month: response?.month,
          Day: response?.day,
          Hour: response?.hour,
          Minute: response?.minute,
          // Latitude: response?.latitude,
          // Longitude: response?.longitude,
          // Timezone: response?.timezone,
          Seconds: response?.seconds,
          Ayanamsha: response?.ayanamsha,
          Sunrise: convertTo12Hour(response?.sunrise),
          Sunset: convertTo12Hour(response?.sunset),
        }));
      } else {
        setLoader(false);

        console.error("Error fetching data: ", response);
      }
    } catch (error) {
      setLoader(false);

      console.error("Error", error);
    }
  };
  const GetAstroDetails = async (apiParam) => {
    try {
      const response = await astro_details(apiParam);
      if (response !== null && response !== undefined) {
        // setLoader(false);

        setAstroDetailsObj((prev) => ({
          ...prev,
          Ascendant: response?.ascendant,
          AscendantLord: response?.ascendant,
          Varna: response?.Varna,
          Vashya: response?.Vashya,
          Yoni: response?.Yoni,
          Gan: response?.Gan,
          Nadi: response?.Nadi,
          SignLord: response?.SignLord,
          Sign: response?.sign,
          Naksahtra: response?.Naksahtra,
          NaksahtraLord: response?.NaksahtraLord,
          Charan: response?.Charan,
          Yog: response?.Yog,
          Karan: response?.Karan,
          Tithi: response?.Tithi,
          Yunja: response?.yunja,
          Tatva: response?.tatva,
          Alphabet: response?.name_alphabet,
          Paya: response?.paya,
        }));
      } else {
        // setLoader(false);

        console.error("Error fetching data: ", response);
      }
    } catch (error) {
      // setLoader(false);

      console.error("Error", error);
    }
  };
  return (
    <>
      <section className="page-header" style={{ paddingBottom: '28px' }}>
        <div
          className="page-header__bg horoscope-banner-responsive"
          style={{ backgroundImage: `url(${HoroscopeBannerImg})` }}
        ></div>
        <div className="container" style={{ display: 'block' }}>
          <h2 className="page-header__title bw-split-in-left">Astro Details</h2>
          <div >
            <Breadcrumbs />
          </div>
        </div>
      </section>


      <div className="container pt-4">
        {/* Mobile horizontal scroll */}
        <div className="d-flex d-md-none overflow-auto px-2">
          {categories.map((category, index) => (
            <div
              key={index}
              className="text-center me-3 flex-shrink-0"
              style={{ width: "100px", cursor: "pointer" }}
              onClick={() => navigate(`${category?.route}`)}
            >
              <div
                className="rounded-circle bg-white shadow d-flex align-items-center justify-content-center mx-auto"
                style={{ width: "70px", height: "70px" }}
              >
                <img
                  src={category.icon}
                  alt={category.title}
                  style={{
                    maxWidth: "50px",
                    maxHeight: "50px",
                    objectFit: "contain",
                  }}
                />
              </div>
              <p
                className="mt-2 fw-semibold"
                style={{
                  color:
                    category?.route === location?.pathname
                      ? "#a52444"
                      : "#212529",
                }}
              >
                {category.title}
              </p>
            </div>
          ))}
        </div>

        {/* Desktop grid layout */}
        <div className="row justify-content-center text-center g-4 d-none d-md-flex">
          {categories.map((category, index) => (
            <div
              key={index}
              className="col-6 col-sm-4 col-md-2"
              style={{ cursor: "pointer" }}
              onClick={() => navigate(`${category?.route}`)}
            >
              <div
                className="rounded-circle bg-white shadow d-flex align-items-center justify-content-center mx-auto"
                style={{ width: "70px", height: "70px" }}
              >
                <img
                  src={category.icon}
                  alt={category.title}
                  style={{
                    maxWidth: "50px",
                    maxHeight: "50px",
                    objectFit: "contain",
                  }}
                />
              </div>
              <p
                className="mt-2 fw-semibold"
                style={{
                  color:
                    category?.route === location?.pathname
                      ? "#a52444"
                      : "#212529",
                }}
              >
                {category.title}
              </p>
            </div>
          ))}
        </div>
      </div>
      <div
        className="min-h-screen bg-cover bg-center bg-no-repeat py-10 px-4"
      // style={{
      //   backgroundImage: `url(${astroBackgroundImg})`,
      //   backgroundBlendMode: 'overlay',
      //   backgroundColor: 'rgba(0, 0, 0, 0.5)',
      //   backgroundSize: "cover",
      //   filter: 'brightness(0.8)'
      // }}
      >

        {/* <h2 className="text-4xl   font-bold text-center mb-10 drop-shadow-lg">
          Astro Details
        </h2> */}
        <div className="container" >
          <div className="row">
            {/* Basic Details - Small Column */}
            <div className={`col-12 col-md-4 mb-4 ${animate ? "slide-in-left" : "opacity-0"}`}>
              <div className="glass-card p-3 h-100" >
                <h3 className="text-center mb-3 fw-bold horoscopeHeaderFont">Basic Details</h3>
                <table className="table table-sm ">
                  <tbody>
                    {labels.map((label, index) => {
                      // if (index % 2 !== 0) return null;
                      const secondLabel = labels[index + 1];
                      return (
                        <tr key={index}>
                          <td className=" horoscopeFont">{label}</td>
                          <td>:</td>
                          <td className=" text-start  horoscopeFont">{basicDetails[label]}</td>

                          {/* {secondLabel ? (
                            <>
                              <td className="text-muted ps-4">{secondLabel}</td>
                              <td>:</td>
                              <td className="text-danger text-end ">{basicDetails[secondLabel]}</td>
                            </>
                          ) : (
                            <>
                              <td></td><td></td><td></td>
                            </>
                          )} */}
                        </tr>
                      );
                    })}
                  </tbody>
                </table>
              </div>
            </div>

            {/* Astro Details - Larger Column */}
            <div className={`col-12 col-md-8 mb-4 ${animate ? "slide-in-right" : "opacity-0"}`}>
              <div className="glass-card p-3">
                <h3 className="text-center mb-3 fw-bold horoscopeHeaderFont">Astro Details</h3>
                <table className="table table-sm w-100">
                  <tbody>
                    {AstroLabels.map((label, index) => {
                      if (index % 2 !== 0) return null;
                      const secondLabel = AstroLabels[index + 1];

                      return (
                        <React.Fragment key={index}>
                          {/* Desktop / Tablet Row */}
                          <tr className="d-none d-md-table-row">
                            <td className=" horoscopeFont">{label}</td>
                            <td>:</td>
                            <td className="text-start  horoscopeFont">
                              {astroDetails[label]}
                            </td>

                            {secondLabel ? (
                              <>
                                <td className=" ps-4 horoscopeFont">{secondLabel}</td>
                                <td>:</td>
                                <td className="text-start  horoscopeFont">
                                  {astroDetails[secondLabel]}
                                </td>
                              </>
                            ) : (
                              <>
                                <td></td><td></td><td></td>
                              </>
                            )}
                          </tr>

                          {/* Mobile Rows */}
                          <tr className="d-table-row d-md-none">
                            <td className=" horoscopeFont">{label}</td>
                            <td>:</td>
                            <td className="text-start  horoscopeFont">
                              {astroDetails[label]}
                            </td>
                          </tr>
                          {secondLabel && (
                            <tr className="d-table-row d-md-none">
                              <td className=" horoscopeFont">{secondLabel}</td>
                              <td>:</td>
                              <td className="text-start  horoscopeFont">
                                {astroDetails[secondLabel]}
                              </td>
                            </tr>
                          )}
                        </React.Fragment>
                      );
                    })}
                  </tbody>
                </table>


              </div>
            </div>
          </div>
        </div>


      </div>
    </>
  );
};

export default BasicDetails;
